'use strict';

/**
 * @param {*} value
 * @returns {boolean}
 */
export default function toBoolean(value) {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true' || value === '1';
    }
    return !!value;
}
